import { Injectable } from '@angular/core';
import { AmplitudeService } from 'app/shared/services/amplitude.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeRouteListenerService {
  private previousUrl: string;

  constructor(private amplitudeService: AmplitudeService, private router: Router) {}

  public startListening() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map((event: NavigationEnd) => this.getRootPath(event.url)),
        filter((url: string) => url !== this.previousUrl)
      )
      .subscribe((url: string) => {
        this.amplitudeService.logEvent('Panel: Route change', {
          url
        });
        this.previousUrl = url;
      });
  }

  private getRootPath(url: string) {
    const urlWithoutLeadingSlash = url.substring(1);
    const firstSlash = urlWithoutLeadingSlash.indexOf('/');
    if (firstSlash === -1 || urlWithoutLeadingSlash.trim() === '') {
      return url;
    }
    return '/' + urlWithoutLeadingSlash.substring(0, firstSlash);
  }
}
